import { Star } from "lucide-react";
import type { Lang } from "@/lib/translations";

interface ReviewsBarProps {
  lang: Lang;
  className?: string;
}

/**
 * Multi-platform reviews trust bar (Google + Yelp).
 * Links to real business profiles for verification.
 */
export default function ReviewsBar({ lang, className = "" }: ReviewsBarProps) {
  const label = lang === "en" ? "Rated across platforms" : "Reseñas en múltiples plataformas";

  const platforms = [
    {
      name: "Google",
      rating: "4.8",
      count: "50+",
      href: "https://share.google/oE39PeBHBc2IO4XBk",
      color: "text-[#4285F4]",
    },
    {
      name: "Yelp",
      rating: "5.0",
      count: lang === "en" ? "Verified" : "Verificado",
      href: "https://www.yelp.com/biz/eg-construction-san-diego-4",
      color: "text-[#D32323]",
    },
  ];

  return (
    <div className={`inline-flex flex-col items-center gap-2 ${className}`}>
      <p className="text-xs font-heading font-bold uppercase tracking-[0.18em] text-muted-foreground">
        {label}
      </p>
      <div className="flex flex-wrap items-stretch justify-center gap-2">
        {platforms.map((p) => (
          <a
            key={p.name}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 rounded-full border border-border bg-card px-4 py-2 shadow-sm hover:border-primary hover:shadow-md transition-all"
            aria-label={`${p.name} reviews for EG Construction — ${p.rating} stars`}
          >
            <span className={`font-heading font-extrabold text-sm ${p.color}`}>{p.name}</span>
            <span className="h-4 w-px bg-border" aria-hidden />
            <span className="flex items-center gap-1">
              <span className="font-heading font-bold text-sm text-foreground">{p.rating}</span>
              <Star className="h-3.5 w-3.5 fill-primary text-primary" />
            </span>
            <span className="text-xs text-muted-foreground">{p.count}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
